export default __webpack_public_path__ + "static/a1-4f893d845e5ddfe6b843454923d29787.png";